<template>
  <div class="bg_gray">
    <div class="fixed">
      <div class="top_header top_sm">
        <div class="m_flex_box flex_vc flex_jz top_normal">
          <van-icon name="arrow-left" @click="$router.go(-1)" />
          <p>线下业务预约</p>
          <i to="/addApply" class="right" @click="show = true">预约说明</i>
        </div>
      </div>
    </div>
    <div class="pad_top"></div>
    <van-form @submit="onSubmit" validate-trigger="onSubmit">
      <div class="main_ bor_b">
        <div>
          <van-field
            readonly
            clickable
            name="picker"
            :value="appType"
            label="预约业务类型"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择预约业务类型' }]"
            @click="showAppType = true"
          />
          <van-popup v-model="showAppType" position="bottom">
            <van-picker
              show-toolbar
              value-key="t"
              :columns="appTypeList"
              @confirm="onConfirmApptype"
              @cancel="showAppType = false"
            />
          </van-popup>
        </div>
        <div>
          <van-field
            readonly
            clickable
            name="picker"
            :value="area"
            label="可办理的区域"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择可办理的区域' }]"
            @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-picker
              show-toolbar
              value-key="t"
              :columns="areaList"
              @confirm="onConfirmArea"
              @cancel="showArea = false"
            />
          </van-popup>
        </div>
        <div>
          <van-field
            readonly
            clickable
            name="picker"
            :value="branchId"
            label="可办理网点"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择可办理网点' }]"
            @click="showBranch = true"
          />
          <van-popup v-model="showBranch" position="bottom">
            <van-picker
              show-toolbar
              value-key="branchName"
              :columns="list1"
              @confirm="onConfirmBranch"
              @cancel="showBranch = false"
            />
          </van-popup>
        </div>
        <div>
          <van-field
            readonly
            clickable
            name="picker"
            :value="time"
            label="可预约时间"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择可预约时间' }]"
            @click="showTime = true"
          />
          <van-popup v-model="showTime" position="bottom">
            <van-picker
              show-toolbar
              value-key="time"
              :columns="list2"
              @confirm="onConfirmTime"
              @cancel="showTime = false"
            />
          </van-popup>
        </div>
        <div v-show="formData.appType == 2 || formData.appType == 3">
          <van-field
            readonly
            clickable
            name="picker"
            :value="contractId"
            label="预约合同号"
            placeholder="请选择"
            :rules="[{ required: false, message: '请选择预约合同号' }]"
            @click="showCon = true"
          />
          <van-popup v-model="showCon" position="bottom">
            <van-picker
              show-toolbar
              value-key="contractId"
              :columns="list3"
              @confirm="onConfirmTimeCon"
              @cancel="showCon = false"
            />
          </van-popup>
        </div>
      </div>
      <div>
        <van-field
          v-show="formData.appType == 1"
          v-model="bargainor"
          name="realName"
          label="出卖方姓名"
          placeholder="请输入出卖方姓名"
          :rules="[{ required: false, message: '请填写出卖方姓名' }]"
        />
        <van-field
          v-show="formData.appType == 1"
          v-model="purchaser"
          name="realName"
          label="买受方姓名"
          placeholder="请输入买受方姓名"
          :rules="[{ required: false, message: '请填写买受方姓名' }]"
        />
        <van-field
          v-show="formData.appType == 1"
          v-model="ownerNo"
          name="realName"
          label="不动产证/房证号"
          placeholder="请输入不动产证/房证号"
          :rules="[{ required: false, message: '请填写不动产证/房证号' }]"
        />
        <van-field
          v-show="formData.appType == 1"
          v-model="houseAddress"
          name="realName"
          label="交易房屋坐落"
          placeholder="请输入交易房屋坐落"
          :rules="[{ required: false, message: '请填写交易房屋坐落' }]"
        />
        <van-field
          v-model="appMsg"
          name="realName"
          label="预约备注"
          placeholder="请输入预约备注"
        />
        <div class="main_b" v-show="formData.appType == 1">
          <div class="blue_con">
            <h4>*重要提醒</h4>
            <p style="color:red;">公积金与组合贷业务请选择北江大厦分点</p>
            <p>
              二手房预约需输入交易双方及房产信息，该信息将被用做线下业务受理使用，请如实填写
            </p>
            <p>若您填写的信息与实际业务受理信息不符，将不予受理</p>
            <p>预约需业务办理本人进行预约，第三方代为预约无效，请知晓！</p>
          </div>
        </div>
      </div>
      <div class="btn_con">
        <van-button block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
    <div class="m_flex_box flex_vc flex_hc opc_cover" v-show="show">
      <div class="wrapper">
        <h5>预约说明</h5>
        <div class="content_">
          <div>
            <p>1、预约需业务办理本人进行预约，第三方代为预约无效，请知晓！</p>
            <p>
              2、预约成功后，预约将正式生效，请买、卖双方及共有人于约定时间前往网点办理；逾期未办理，将不保留预约信息；
            </p>
            <p>
              3、预约成功后，现场业务办理以预约序号顺序为准，现场不再单独叫号，过号作废，需重新预约。
            </p>
            <p>
              4、若预约时间已满，该预约时间将不显示；若已预约用户取消预约，系统将恢复该可预约号段，其他用户可选择预约
            </p>
            <p>
              5、办理商业贷款的二手房网签业务，不要进行预约，请前往贷款银行办理
            </p>
            <p>
              6、一个预约号，仅可预约办理买卖双方分别为同一人的最多两套房产业务
            </p>
          </div>
        </div>
        <div class="btn" @click="show = false">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { Dialog } from "vant";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      appTypeList: [
        {
          v: 1,
          t: "二手房业务预约",
        },
        // {
        //   v: 2,
        //   t: '二手房抵押预约'
        // },{
        //   v: 3,
        //   t: '二手房存取房款预约'
        // }
      ],
      areaList: [
        {
          v: "320",
          t: "市区",
        },
      ],
      userName: "",
      role: "",
      columns: [1],
      comtent: "",
      fileList: [],
      show: true,
      showPicker: false,
      showAppType: false,
      showArea: false,
      showBranch: false,
      showTime: false,
      showCon: false,
      appType: "",
      area: "",
      branchId: "",
      appDate: "",
      list1: [],
      list2: [],
      list3: [],
      time: "",
      finished: false,
      bargainor: "",
      purchaser: "",
      ownerNo: "",
      houseAddress: "",
      appMsg: "",
      contractId: "",
      formData: {
        contractId: "",
        appType: "",
        area: "",
        branchId: "",
        appDate: "",
        appTime: "",
      },
    };
  },
  mounted() {},
  methods: {
    onConfirmApptype(data) {
      this.appType = data.t;
      this.$set(this.formData, "appType", data.v);
      this.showAppType = false;
      this.branchId = "";
      this.$set(this.formData, "branchId", "");
      this.time = "";
      this.$set(this.formData, "appDate", "");
      this.$set(this.formData, "appTime", "");
      this.$set(this, "list1", []);
      this.$set(this, "list2", []);
      this.area = "";
      this.$set(this.formData, "area", "");
      if (this.formData.appType == 2 || this.formData.appType == 3) {
        this.getMyAppointContract();
      }
    },
    onConfirmArea(data) {
      this.area = data.t;
      this.$set(this.formData, "area", data.v);
      this.showArea = false;
      this.getAreaBranchInfoByArea();
    },
    onConfirmBranch(data) {
      this.branchId = data.branchName;
      this.$set(this.formData, "branchId", data.id);
      this.showBranch = false;
      this.getAppointmentConfigTimeListOffline();
    },
    onConfirmTime(data) {
      this.time = data.time;
      this.$set(this.formData, "appDate", data.appDate);
      this.$set(this.formData, "appTime", data.appTime);
      this.showTime = false;
      console.log(this.formData);
    },

    onConfirmTimeCon(data) {
      this.contractId = data.contractId;
      this.$set(this.formData, "contractId", data.id);
      this.showCon = false;
    },

    getAreaBranchInfoByArea() {
      this.$http
        .post(
          "cms/areaBranch/reg/getAreaBranchInfoByArea.do",
          qs.stringify({
            area: "320", //this.$route.query.area
          })
        )
        .then((res) => {
          if (res.success) {
            this.list1 = res.obj;
          } else {
            this.finished = true;
          }
        });
    },

    getAppointmentConfigTimeListOffline() {
      this.$http
        .post(
          "cms/appointmentConfig/reg/getAppointmentConfigTimeListOffline.do",
          qs.stringify({
            branchId: this.formData.branchId,
            appType: this.formData.appType,
          })
        )
        .then((res) => {
          if (res.success) {
            const newArr = [];
            res.obj.forEach(function(item) {
              var num = item.num;
              var time = "上午";
              if (item.appTime == 2) {
                time = "下午";
              }
              item.time =
                item.appDate.substring(0, 10) +
                "-" +
                time +
                "-剩余" +
                num +
                "号";
              newArr.push(item);
            });
            this.$set(this, "list2", newArr);
          } else {
            this.$dialog.alert({
              title: "提示",
              message: res.msg,
            });
            this.finished = true;
          }
        });
    },

    getMyAppointContract() {
      this.$http
        .post("cms/appointment/reg/getMyAppointContract.do", qs.stringify({}))
        .then((res) => {
          if (res.success) {
            const newArr = [];
            res.obj.forEach(function(item) {
              item.contractId =
                item.contrDateNum + item.contrNum + ":" + item.houseAddress;
              newArr.push(item);
            });
            this.$set(this, "list3", newArr);
            this.finished = true;
          } else {
            this.finished = true;
          }
        });
    },

    onSubmit() {
      if (this.formData.appType == 1) {
        if (!this.bargainor) {
          this.$toast("请输入出卖方姓名!");
        }
        if (!this.purchaser) {
          this.$toast("请输入买受方姓名!");
        }
        if (!this.ownerNo) {
          this.$toast("请输入权属证号!");
        }
        if (!this.houseAddress) {
          this.$toast("请输入交易房屋地址!");
        }
        this.$http({
          url: "cms/appointment/reg/doSendAppointmentOffline.do",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            branchId: this.formData.branchId,
            appMsg: this.appMsg,
            appDate: this.formData.appDate,
            appTime: this.formData.appTime,
            appType: this.formData.appType,
            area: this.formData.area,
            bargainor: this.bargainor,
            purchaser: this.purchaser,
            ownerNo: this.ownerNo,
            houseAddress: this.houseAddress,
            contractId: this.formData.contractId,
          },
        }).then((res) => {
          if (res.success) {
            this.$toast(res.msg);
            this.$router.go(-1);
          } else {
            this.$toast(res.msg);
          }
        });
      } else {
        if (!this.formData.contractId) {
          this.$toast("请选择预约合同号!");
        }
        this.$http({
          url: "cms/appointment/reg/doSendAppointmentOffline.do",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            branchId: this.formData.branchId,
            appMsg: this.appMsg,
            appDate: this.formData.appDate,
            appTime: this.formData.appTime,
            appType: this.formData.appType,
            area: this.formData.area,
            contractId: this.formData.contractId,
          },
        }).then((res) => {
          if (res.success) {
            this.$toast(res.msg);
            this.$router.go(-1);
          } else {
            this.$toast(res.msg);
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.bg_gray {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.top_header {
  height: 0.7rem;
  padding: 0.2rem 0rem;
  width: 7.04rem;
  margin: 0 auto;

  &.top_sm {
    padding: 0.1rem;
  }
}

.pad_top {
  padding-top: 0.9rem;
}

.fixed {
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 9;
  border-bottom: 1px solid #f5f5f5;

  .top_normal {
    height: 100%;

    p {
      font-size: 0.32rem;
    }

    i {
      font-size: 0.32rem;
    }

    .right {
      font-size: 0.28rem;
      color: #2f72f5;
    }
  }
}

.btn_con {
  background-color: #fff;
  z-index: 9;
  padding: 0.4rem 0;
  left: 0;
  right: 0;

  /deep/ .van-button {
    height: 0.88rem;
    width: 7.04rem;
    margin: 0 auto;
    border-radius: 0.08rem;
  }
}

.blue_con {
  background-color: #eff4ff;
  color: #2f72f5;
  width: 7.04rem;
  box-sizing: border-box;
  padding: 0.24rem 0.23rem;
  margin: 0 auto 0;
  border-radius: 0.08rem;

  h4 {
    font-weight: 800;
    font-size: 0.26rem;
    margin-bottom: 0.1rem;
  }

  p {
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
}

.main_b {
  padding-top: 0.3rem;
  background-color: #fff;
}

.wrapper {
  height: 9.54rem;
  width: 6.64rem;
  background-color: #fff;

  h5 {
    padding-top: 0.88rem;
    font-size: 0.38rem;
    text-align: center;
    font-weight: 800;
    margin-bottom: 0.5rem;
  }

  .content_ {
    height: 60%;
    box-sizing: border-box;
    padding: 0 0.4rem 0;
    overflow: auto;
    font-size: 0.28rem;

    p {
      margin-bottom: 0.35rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .btn {
    width: 2.92rem;
    line-height: 0.82rem;
    text-align: center;
    color: #fff;
    background-color: #2f72f5;
    border-radius: 0.08rem;
    font-size: 0.28rem;
    margin: 0.45rem auto 0;
  }
}

.opc_cover {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2;
}
</style>
